export default "__VITE_ASSET__CCPTt_YB__"